export const organisationIcon = `
<svg width="100%" height="100%" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="26" height="26"  />
<path d="M19 3H7C5.89543 3 5 3.89543 5 5V21C5 22.1046 5.89543 23 7 23H19C20.1046 23 21 22.1046 21 21V5C21 3.89543 20.1046 3 19 3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 23V19H16V23" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<rect x="14" y="14" width="4" height="3" fill="currentColor"/>
<rect x="14" y="10" width="4" height="3" fill="currentColor"/>
<rect x="14" y="6" width="4" height="3" fill="currentColor"/>
<rect x="8" y="14" width="4" height="3" fill="currentColor"/>
<rect x="8" y="10" width="4" height="3" fill="currentColor"/>
<rect x="8" y="6" width="4" height="3" fill="currentColor"/>
</svg>
`;
